import React, { useEffect, useState } from "react";
import { Row, Col, Table, Badge, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import GenerateCodeModal from "./GenerateCodeModal";
import { activation_codes } from "../../../services/admin";

const ActivationCodesTable = () => {
  const [subscriptionCodes, setSubscriptionCodes] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const fetchData = async () => {
    const response = await activation_codes();

    setSubscriptionCodes(response.subscriptionCodes);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const copyCode = async (code) => {
    await navigator.clipboard.writeText(code);
  };

  return (
    <>
      <Row className="mb-3">
        <Col xs={6}>
          <h4>Códigos de Activación (Suscripciones largas)</h4>
        </Col>

        <Col xs={6} className="text-end">
          <Button variant="primary" onClick={() => setShowModal(true)}>
            Generar código
          </Button>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Código</th>
                <th>Duración</th>
                <th>Usado por</th>
                <th>Fecha de uso</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>
              {subscriptionCodes.map((c) => {
                const isUsed = !!c.usedBy;

                return (
                  <tr key={c._id}>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <code>{c.code}</code>

                        <Button
                          size="sm"
                          variant="outline-secondary"
                          onClick={() => copyCode(c.code)}
                        >
                          <FontAwesomeIcon icon={faCopy} />
                        </Button>
                      </div>
                    </td>

                    <td>
                      {c.durationTime} {c.durationPeriod}
                    </td>

                    <td>{c.usedBy?.correo || "-"}</td>

                    <td>
                      {c.usedAt ? new Date(c.usedAt).toLocaleDateString() : "-"}
                    </td>

                    <td>
                      <Badge bg={isUsed ? "warning" : "success"}>
                        {isUsed ? "Usado" : "Disponible"}
                      </Badge>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Row>

      <GenerateCodeModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onCreated={fetchData}
      />
    </>
  );
};

export default ActivationCodesTable;
